/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type RoleSelectionRequest = {
    /**
     * Index of the stage (0-based)
     */
    stage_index: number;
    /**
     * Type of role: expert or producer
     */
    role_type: RoleSelectionRequest.role_type;
    /**
     * Index of the task within the stage and role (0-based)
     */
    task_index: number;
    /**
     * Whether the task is selected or not
     */
    is_selected: boolean;
};
export namespace RoleSelectionRequest {
    /**
     * Type of role: expert or producer
     */
    export enum role_type {
        EXPERT = 'expert',
        PRODUCER = 'producer',
    }
}

